import { useEffect, useRef } from 'react';
import { playNotificationSound } from '../lib/audio';

export const useSoundOnUnreadIncrease = (unreadCount: number, isReady = true): void => {
  const prevCountRef = useRef<number | null>(null);

  useEffect(() => {
    if (!isReady) {
      return;
    }

    if (prevCountRef.current === null) {
      prevCountRef.current = unreadCount;
      return;
    }

    if (unreadCount > prevCountRef.current) {
      playNotificationSound();
    }

    prevCountRef.current = unreadCount;
  }, [unreadCount, isReady]);
};